// /* eslint-disable */
// import React, { useState, useEffect } from "react";
// import Suppliers from "./Suppliers";
// import EditSupplier from "./EditSupplier";
// import {
//   getAllSuppliers,
//   getSuppliersByUser,
// } from "../../actions/supplierActions";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation, useHistory } from "react-router-dom";
// import NoData from "../svgIcons/NoData";
// import Spinner from "../Spinner/Spinner";
// import AddSupplier from "./AddSupplier";
// import { IconButton, Tooltip , Button } from "@material-ui/core"; // Import Material-UI components
// import { Add as AddIcon } from "@material-ui/icons"; // Import Add icon

// const SupplierList = () => {
//   const history = useHistory();
//   const [open, setOpen] = useState(false); // For EditSupplier dialog
//   const [openSupplier, setOpenSupplier] = useState(false); // For AddSupplier dialog
//   const location = useLocation();
//   const [currentId, setCurrentId] = useState(null);
//   const dispatch = useDispatch();
//   const user = JSON.parse(localStorage.getItem("profile"));
//   const { suppliers } = useSelector((state) => state.suppliers);
//   //("Suppliers",suppliers)

//   const isLoading = useSelector((state) => state.suppliers.isLoading);
//   // const suppliers = []

//   // useEffect(() => {
//   // }, [currentId, dispatch]);

//   //     useEffect(() => {
//   //         dispatch(getSuppliers(1));
//   //         // dispatch(getSuppliersByUser({userId : user?.result?.id}));
//   //         // dispatch(getSuppliersByUser({ search :user?.result?.id, tags: tags.join(',') }));
//   //     },[location]
//   // )

//   useEffect(() => {
//     dispatch(getAllSuppliers());
//     // dispatch(getSuppliersByUser({ search: user?.result?.id || user.result.googleId }));
//   }, [location]);

//   if (!user) {
//     history.push("/login");
//   }

//   if (isLoading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexDirection: "column",
//           paddingTop: "20px",
//         }}
//       >
//         <Spinner />
//       </div>
//     );
//   }

//   if (suppliers.length === 0) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexDirection: "column",
//           paddingTop: "20px",
//           margin: "80px",
//         }}
//       >
//         <NoData />
//         <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
//           No Suppliers yet. Click the plus icon to add Supplier
//         </p>
//         {/* Add Supplier Button */}
//         <Tooltip title="Add Supplier" arrow>
//           <IconButton
//             onClick={() => setOpenSupplier(true)}
//             style={{ color: "#ef7f1a" }}
//           >
//             <AddIcon />
//           </IconButton>
//         </Tooltip>
//       </div>
//     );
//   }

//   return (
//     <div>
//       {/* Add Supplier Dialog */}
//       <AddSupplier open={openSupplier} setOpen={setOpenSupplier} />
//       <EditSupplier
//         open={open}
//         setOpen={setOpen}
//         currentId={currentId}
//         setCurrentId={setCurrentId}
//       />
//       {/* Suppliers List */}
//       <div
//         style={{ display: "flex", margin: "20px" }}
//       >
//         <Tooltip title="Add Supplier" arrow>
//           <Button
//             onClick={() => setOpenSupplier(true)}
//             style={{ color: "#ef7f1a" }}
//           >
//             Add Supplier
//           </Button>
//         </Tooltip>
//       </div>
//       <Suppliers
//         open={open}
//         setOpen={setOpen}
//         currentId={currentId}
//         setCurrentId={setCurrentId}
//         suppliers={suppliers}
//       />
//     </div>
//   );
// };

// export default SupplierList;


/* eslint-disable */
import React, { useState, useEffect } from "react";
import Suppliers from "./Suppliers";
import EditSupplier from "./EditSupplier";
import {
  getAllSuppliers,
  getSuppliersByUser,
} from "../../actions/supplierActions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import AddSupplier from "./AddSupplier";
import {
  IconButton,
  Tooltip,
  Button,
  Container,
  Grid,
  Typography,
  Paper,
} from "@material-ui/core"; // Added Container, Grid, Typography, Paper
import { Add as AddIcon } from "@material-ui/icons"; // Import Add icon
import { makeStyles } from "@material-ui/core/styles"; // For custom styles

// Define custom styles
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    minHeight: "100vh",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    marginLeft: "115px",
  },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  addButton: {
    backgroundColor: "#ef7f1a",
    color: "#fff",
    textTransform: "none",
    padding: theme.spacing(1, 3),
    "&:hover": {
      backgroundColor: "#d66f15",
    },
  },
  noDataContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
    margin: theme.spacing(4),
    borderRadius: theme.spacing(1),
    backgroundColor: "#fff",
    boxShadow: theme.shadows[3],
    textAlign: "center",
  },
  noDataText: {
    color: theme.palette.text.secondary,
    margin: theme.spacing(2, 0),
  },
  spinnerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    paddingTop: theme.spacing(3),
    minHeight: "50vh",
  },
}));

const SupplierList = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [open, setOpen] = useState(false); // For EditSupplier dialog
  const [openSupplier, setOpenSupplier] = useState(false); // For AddSupplier dialog
  const [currentId, setCurrentId] = useState(null);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile"));
  const { suppliers } = useSelector((state) => state.suppliers);
  //("Suppliers",suppliers)

  const isLoading = useSelector((state) => state.suppliers.isLoading);
  // const suppliers = []

  // useEffect(() => {
  // }, [currentId, dispatch]);

  //     useEffect(() => {
  //         dispatch(getSuppliers(1));
  //         // dispatch(getSuppliersByUser({userId : user?.result?.id}));
  //         // dispatch(getSuppliersByUser({ search :user?.result?.id, tags: tags.join(',') }));
  //     },[location]
  // )

  useEffect(() => {
    dispatch(getAllSuppliers());
    // dispatch(getSuppliersByUser({ search: user?.result?.id || user.result.googleId }));
  }, [location]);

  if (!user) {
    history.push("/login");
  }

  if (isLoading) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner />
      </div>
    );
  }

  if (suppliers.length === 0) {
    return (
      <Container maxWidth="md" className={classes.root}>
        <Paper elevation={3} className={classes.noDataContainer}>
          <NoData />
          <Typography variant="h6" className={classes.noDataText}>
            No Suppliers yet. Click the button below to add a Supplier.
          </Typography>
          <Tooltip title="Add Supplier" arrow>
            <Button
              variant="contained"
              className={classes.addButton}
              startIcon={<AddIcon />}
              onClick={() => setOpenSupplier(true)}
            >
              Add Supplier
            </Button>
          </Tooltip>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" className={classes.root}>
      {/* Add Supplier Dialog */}
      <AddSupplier open={openSupplier} setOpen={setOpenSupplier} />
      <EditSupplier
        open={open}
        setOpen={setOpen}
        currentId={currentId}
        setCurrentId={setCurrentId}
      />
      {/* Header with Title and Add Button */}
      <div className={classes.header}>
        {/* <Typography variant="h5" className={classes.title}>
          Suppliers
        </Typography> */}
        <Tooltip title="Add Supplier" arrow>
          <Button
            variant="contained"
            className={classes.addButton}
            startIcon={<AddIcon />}
            onClick={() => setOpenSupplier(true)}
          >
            Add Supplier
          </Button>
        </Tooltip>
      </div>
      {/* Suppliers List */}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Suppliers
            open={open}
            setOpen={setOpen}
            currentId={currentId}
            setCurrentId={setCurrentId}
            suppliers={suppliers}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default SupplierList;